export default __webpack_public_path__ + "static/tiresDesktop-49e8a31461316c359c07ce547050513e.webp";